/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GroupAdmin = {
    properties: {
        id: {
    type: 'number',
},
        groupId: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
    },
};